import { ReferralsApplicationAnswer } from '@recruitee/http/types';
import {
  createEntityCollectionStore,
  DEFAULT_SCOPE_NAME,
  getEntityCollectionActions,
} from '@recruitee/ngrx';

const { actions, selectors, reducer, namespace } =
  createEntityCollectionStore<ReferralsApplicationAnswer>()('ReferralsApplicationAnswers', {
    customActions: adapter => {
      const defaultActions = getEntityCollectionActions(adapter, ({ id }) => id!);
      return {
        fetchCollection: (state, payload: { candidateId: number }) =>
          defaultActions.fetchCollection(state, {
            scope: DEFAULT_SCOPE_NAME,
          }),
      };
    },
  });

const ReferralsApplicationAnswersActions = <
  Pick<typeof actions, 'fetchCollection' | 'fetchCollectionSuccess' | 'fetchCollectionFailed'>
>actions;

export {
  ReferralsApplicationAnswersActions,
  reducer as ReferralsApplicationAnswersReducer,
  selectors as ReferralsApplicationAnswersSelectors,
  namespace as ReferralsApplicationAnswersNamespace,
};
